import moment from 'moment'

export default {

    filters: {
        mascaraCpf(valor) {
            const arr = valor.split('')
            arr.splice(3, 0, '.')
            arr.splice(7, 0, '.')
            arr.splice(11, 0, '-')
            return arr.join('')
        }
    },
    methods: {
        formatarData(data) {
            return moment(data).format('DD/MM/YYYY')
        },
        isEmpty(value) {
            return value == null || value == '' || value.toString().trim() == '';
        },

        mascaraCpf(valor) {
            var arr = valor.split('')
            arr.splice(3, 0, '.')
            arr.splice(7, 0, '.')
            arr.splice(11, 0, '-')
            return arr.join('')
        },

        mascaraCnpj(valor) {
            var CNPJ = valor;
            var CNPJAux = '';
            var campo1 = '';


            if (CNPJ.length < 15) {
                for (var i = 0; i < CNPJ.length; i++) {
                    CNPJAux = CNPJAux + CNPJ.substr(i, 1);
                    if (i == 1 || i == 4) {
                        CNPJAux = CNPJAux + ".";
                    }
                    if (i == 7) {
                        CNPJAux = CNPJAux + "/";
                    }
                    if (i == 11) {
                        CNPJAux = CNPJAux + "-";
                    }
                }
                campo1 = CNPJAux;
            } else {
                campo1 = CNPJ;
            }

            return campo1;
        },

        mascaraCnj(valor) {
            var arr = valor.split('')
            arr.splice(7, 0, '-')
            arr.splice(10, 0, '.')
            arr.splice(15, 0, '.')
            arr.splice(17, 0, '.')
            arr.splice(20, 0, '.')
            return arr.join('')
        },
        validarCpf(cpf) {
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf == '') return false;

            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;

            let add = 0;

            for (let i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
            for (let i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        },

        validarCnpj(cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g, '');

            if (cnpj == '') return false;

            if (cnpj.length != 14)
                return false;


            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false;


            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;

            return true;
        },

		validarCnpjAlfanumerico(cnpj) {
            if (!cnpj || typeof cnpj !== 'string') {
                return false
            }

            // Remove caracteres especiais
            const limpo = cnpj.replace(/[^\w]/g, '').toUpperCase();

            if (limpo.length !== 14) {
                return false
            }

            const base = limpo.slice(0, 12);
            const dvInformado = limpo.slice(12, 14);

            const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            const dv1 = this.calcularDV(base, pesos1);
            if (dv1 < 0) return false;

            const pesos2 = [6].concat(pesos1);
            const dv2 = this.calcularDV(base + dv1, pesos2);
            if (dv2 < 0) return false;

            return dvInformado === `${dv1}${dv2}`;
        },
        calcularDV(base, pesos) {
            let soma = 0;
            for (let i = 0; i < base.length; i++) {
                const valor = this.charToInt(base[i]);
                if (valor < 0) return -1;
                soma += valor * pesos[i];
            }
            const resto = soma % 11;
            return (resto < 2) ? 0 : 11 - resto;
        },
        charToInt(char) {
            const code = char.charCodeAt(0);
            if (code >= 48 && code <= 57) return code - 48;
            if (code >= 65 && code <= 90) return code - 48;
            return -1;
        },

        validaCnj(cnj) {

            if (cnj != '' && cnj.length < 20) {
                return false;
            }

            cnj = cnj.replace(/[^\d]+/g, '');

            var cnjSemDigito = cnj.substring(0, 7) + cnj.substring(9, 20) + "00";
            var digitoVerificador = cnj.substring(7, 9);

            var nnnnnnn = parseInt(cnjSemDigito.substring(0, 7));
            var ajtr = cnjSemDigito.substring(7, 14);
            var oooo00 = cnjSemDigito.substring(14, 20);

            /*
             * Fórmula CNJ primeira etapa R1 = (NNNNNNN mod 97)
             */
            var r1 = nnnnnnn % 97;

            /*
             * Fórmula CNJ segunda etapa R2 = ((R1 concatenado com AAAAJTR) mod 97)
             */
            var r2 = parseInt(r1 + '' + ajtr) % 97;

            /*
             * Fórmula CNJ terceira etapa R3 = ((R2 concatenado com OOOO00) mod 97)
             */
            var r3 = (r2 + '' + oooo00) % 97;

            /*
             * Fórmula CNJ quarta etapa DD = 98 - (R3 mod 97)
             */
            var d1d0 = 98 - r3;
            if (d1d0.toString().length == 1) {
                d1d0 = 0 + '' + d1d0;
            }

            // Compara dígito calculado com informado
            var big = cnjSemDigito.substring(0, 18) + '' + d1d0;
            if (digitoVerificador == d1d0 && this.modulo(big, 97) == 1) {
                return true;
            } else {
                return false;
            }
        },

        modulo(divident, divisor) {
            var cDivident = '';
            var cRest = '';

            for (var i in divident) {
                var cChar = divident[i];
                var cOperator = cRest + '' + cDivident + '' + cChar;

                if (cOperator < parseInt(divisor)) {
                    cDivident += '' + cChar;
                } else {
                    cRest = cOperator % divisor;
                    if (cRest == 0) {
                        cRest = '';
                    }
                    cDivident = '';
                }

            }
            cRest += '' + cDivident;
            if (cRest == '') {
                cRest = 0;
            }
            return cRest;
        },

        formatarDecimal(value, nonDecimalSize, decimalSize) {
            if (value == null) {
                return value;
            }
            value = value.toString().replace(/[^1234567890,-]/g, "");
            var valorFinal = "";
            for (let i = 0; i < value.length; i++) {
                if (value[i] == '-') {
                    if (i == 0) {
                        valorFinal += "-";
                    }
                    continue;
                }
                if (value[i] == ',' && valorFinal == '') {
                    valorFinal += "0";
                }
                if (value[i] == ',' && (valorFinal.match(new RegExp(",", "g")) || []).length == 0) {
                    valorFinal += ",";
                }
                if (value[i] != ',') {
                    if ((valorFinal.match(new RegExp(",", "g")) || []).length > 0) {
                        let valorFinalSplit = valorFinal.split(",")[1];
                        if (valorFinalSplit.length < decimalSize) {
                            valorFinal += value[i];
                        }
                    } else if (valorFinal.length < nonDecimalSize) {
                        valorFinal += value[i];
                    }
                }
            }
            return valorFinal;
        },
        formatarMonetarioExibir(value, nonDecimalSize, decimalSize) {
            if (value != null) {
                value = value.toString();
                if (value.split(".").length <= 1) {
                    value += "00";
                } else if (value.split(".")[1].length == 1) {
                    value += "0";
                }

                return this.formatarMonetario(value, nonDecimalSize, decimalSize);
            }

            return value;
        },
        formatarDecimalPositivo(value, nonDecimalSize, decimalSize) {
            if (value == null) {
                return value;
            }
            if (decimalSize == 0) {
                value = value.toString().replace(/[^1234567890]/g, "");
            } else {
                value = value.toString().replace(/[^1234567890,]/g, "");
            }
            var valorFinal = "";
            for (let i = 0; i < value.length; i++) {
                if (value[i] == '-') {
                    if (i == 0) {
                        valorFinal += "-";
                    }
                    continue;
                }
                if (value[i] == ',' && valorFinal == '') {
                    valorFinal += "0";
                }
                if (value[i] == ',' && (valorFinal.match(new RegExp(",", "g")) || []).length == 0) {
                    valorFinal += ",";
                }
                if (value[i] != ',') {
                    if ((valorFinal.match(new RegExp(",", "g")) || []).length > 0) {
                        let valorFinalSplit = valorFinal.split(",")[1];
                        if (valorFinalSplit.length < decimalSize) {
                            valorFinal += value[i];
                        }
                    } else if (valorFinal.length < nonDecimalSize) {
                        valorFinal += value[i];
                    }
                }
            }
            return valorFinal;
        },

        formatarMonetario(value) {
            if (value == null) {
                return value;
            }
            value = value.toString().replace(/[^1234567890]/g, "");
            var valorFinal = "";
            for (let i = value.length - 1; i >= 0; i--) {
                if (valorFinal.length == 2) {
                    valorFinal = "," + valorFinal;
                } else if (valorFinal.length == 6 || valorFinal.length == 10 || valorFinal.length == 14
                    || valorFinal.length == 18 || valorFinal.length == 22) {
                    valorFinal = "." + valorFinal;
                }
                valorFinal = value[i] + valorFinal;
            }

            return valorFinal;
        },

        formatarMonetarioForcar(value) {
            if (this.verificarValorVazio(value)) {
                return value;
            }

            value = value.toString().replace(/[^1234567890]/g, "");
            if (this.verificarValorVazio(value)) {
                return value;
            }

            value = parseInt(value.toString().replace(/[^1234567890]/g, "")).toString();
            var valorFinal = "";
            for (let i = value.length - 1; i >= 0; i--) {
                if (valorFinal.length == 2) {
                    valorFinal = "," + valorFinal;
                } else if (valorFinal.length == 6 || valorFinal.length == 10 || valorFinal.length == 14
                    || valorFinal.length == 18 || valorFinal.length == 22) {
                    valorFinal = "." + valorFinal;
                }
                valorFinal = value[i] + valorFinal;
            }

            if(valorFinal.length == 1) {
                valorFinal = '0,0' + valorFinal;
            } else if(valorFinal.length == 2) {
                valorFinal = '0,' + valorFinal;
            }

            return valorFinal;
        },

        formatarMonetarioSemCasa(value) {
            if (value == null) {
                return value;
            }
            value = value.toString();
            if (value.split(".").length <= 1) {
                value += "00";
            } else if (value.split(".")[1].length == 1) {
                value += "0";
            }

            value = value.replace(/[^1234567890]/g, "");
            var valorFinal = "";
            for (let i = value.length - 1; i >= 0; i--) {
                if (valorFinal.length == 2) {
                    valorFinal = "," + valorFinal;
                } else if (valorFinal.length == 6 || valorFinal.length == 10 || valorFinal.length == 14
                    || valorFinal.length == 18 || valorFinal.length == 22) {
                    valorFinal = "." + valorFinal;
                }
                valorFinal = value[i] + valorFinal;
            }

            return valorFinal;
        },

        formatarNumericoComEnter(value) {
            return value.replace(/[^1234567890\n\r]/g, "");
        },

        removeSpecialCharacters(value) {
            return value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ ]/g, "");
        },

        removeSpecialCharactersGeral(value) {
            return value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890@_\.\-()\[\] ]/g, "");
        },

        removeSpecialCharactersGeralVirgula(value) {
            return value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890@_,\.\-()\[\] ]/g, "");
        },

        removeSpecialCharactersNumero(value) {
            return value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890 ]/g, "");
        },

        verificarValorVazio(valor) {
            return null == valor || undefined == valor || valor.toString().trim() === "";
        },

        exibirErro(error) {
            if (error.response != null && error.response.data != null) {
                this.$store.commit("setMessages", {message: 'Erro!', variant: 'danger', errors: [error.response.data]});
            } else {
                this.$store.commit("setMessages", {message: 'Erro!', variant: 'danger', errors: [error]});
            }
            window.scrollTo(0, 0);
        },

        exibirMensagem(msg) {
            this.$store.commit("setMessages", {
                message: 'Atenção', variant: 'danger', errors: [{
                    message: msg
                }]
            });
            window.scrollTo(0, 0);
        },
        tratarCamposNumericos(valor) {
            return valor != null ?
                valor.toString().replace(/[^1234567890,]/g, "").replace(",", ".") : null;
        },
        tratarCamposNumericosFloat(valor) {
            return !this.verificarValorVazio(valor) ?
                parseFloat(valor.toString().replace(/[^1234567890,]/g, "").replace(",", ".")) : null;
        },
        removeDiacritics(text) {
            return text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        },
        normalizedContains(needle, haystack) {
            const regExp = new RegExp(this.removeDiacritics(needle), 'gi');
            return regExp.test(this.removeDiacritics(haystack.nome));
        },
        searchChangeSetor(search) {
            this.dados.setoresFiltrados = search
                ? this.dados.setores.filter(option => this.normalizedContains(search, option)
        )
        :
            this.dados.setores;
        },
        validateEmail(field, validation) {
            if (field != null && field != '' && field.match('.+[@]+.') == null) {
                validation.valid = false;
                return false;
            } else {
                validation.valid = true;
                return true;
            }
        },
        hideModal(nome) {
            this.$refs[nome].hide();
        },
        showModal(nome) {
            this.$refs[nome].show();
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        toFixed(operacao) {
            return +(operacao).toFixed(12);
        },
        onlyNumber(numero) {
            return numero.replace(/[^\d]+/g, '');
        },

        adicionarErroDeValidacao(attributeValidation, message){
            attributeValidation.valid = false;
            attributeValidation.message = message;
        },

        validarCampoObrigatorio(value, attributeValidation) {
            if (this.verificarValorVazio(value)) {
                this.adicionarErroDeValidacao(attributeValidation, "Campo obrigatório");
            }
         },

        limparErroDeValidacao(attributeValidation){
            attributeValidation.valid = true;
            if(attributeValidation.message != undefined){
                attributeValidation.message = '';
            }
        },

        validarCamposObrigatorios(value, validations){
            this.limparValidations(validations);
            
            for (const attribute in validations) {
                if(value.hasOwnProperty(attribute)){
                    this.validarCampoObrigatorio(value[attribute], validations[attribute], "Campo obrigatório");
                }
             }
        },

        limparValidations(validations){
            for (const attribute in validations) {
                this.limparErroDeValidacao(validations[attribute]);
             }
        },

        validationsContainsError(validations){
            for (const attribute in validations) {
                if(!validations[attribute].valid){
                    return true;
                }
             }
             return false;
        },

        adicionarCasas(value){
            if (this.verificarValorVazio(value)) {
                return value;
            }
            value = value.toString();
            if (value.split(",").length <= 1) {
                value += ",00";
            }

            return value;
        }
    }
}
